import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Store } from 'react-notifications-component';
import PropTypes from 'prop-types';

import Handle from '../Handle';
import CategoryIcon from './Icon';
import ServicesDropdown from '../../../../../../../../../components/Dropdown/ServicesDropdown';

import { getErrorMessage, getHighlightingText, getServicesListSortByRate } from '../../../../../../helpers/getters';
import {
  showCategory,
  hideCategory,
  openModal,
  serviceTableLoading,
  changePositionCategory,
  changePositionCategoryError,
} from '../../../../../../reducer';
import { ACTION } from '../../../../../../constants';
import { servicesChangePositionServices, categoryServicesCheckedAdd } from '../../../../../../../../../redux/actions/services';

const RowCategory = ({ style, search, searchOption, serviceDispatch, category }) => {
  const dispatch = useDispatch();

  const { id, show, visibility, isStyleDisable, name, servicesLength, isDropdownDropUp, highlight, isActiveFilters, icon } = category;

  const { config } = useSelector((state) => state.services);

  const access = config?.access;

  const [firstRender, setFirstRenter] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFirstRenter(false);
    }, 350);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const onChangeCollapse = () => {
    if (show) {
      serviceDispatch(hideCategory(id));
    } else {
      serviceDispatch(showCategory(id));
    }
  };

  const onSortPositionByRate = async (selectedValue) => {
    const { value, id } = selectedValue;
    await serviceDispatch(serviceTableLoading());
    const positions = await getServicesListSortByRate(value, id);
    try {
      await dispatch(servicesChangePositionServices(id, positions));
      await serviceDispatch(changePositionCategory(id));
      return true;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      Store.addNotification({
        title: 'Error',
        message: errorMessage,
        type: 'danger',
        insert: 'top',
        container: 'bottom-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 3000,
        },
      });
      await serviceDispatch(changePositionCategoryError());
      return false;
    }
  };

  const onChangeAction = (selectedValue) => {
    const { value } = selectedValue;

    switch (value) {
    case 'CATEGORY_SERVICES_SELECT':
      return dispatch(categoryServicesCheckedAdd(category.id));
    case ACTION.SORT_POSITION_HIGH_TO_LOW:
    case ACTION.SORT_POSITION_LOW_TO_HIGH:
      return onSortPositionByRate(selectedValue);
    default:
      return serviceDispatch(openModal(value, category));
    }
  };

  const categoryActions = category.actions;

  return (
    <div
      className={classNames('service-table__category', {
        'service-table__category-disabled': !visibility || isStyleDisable,
        'service-table__row-highlight': highlight,
      })}
      id={`category-${id}`}
      style={style}
    >
      {!search && !isActiveFilters && access.edit_category && id ? (
        <div className="service-table__category-handle">
          <Handle active={!firstRender} />
        </div>
      ) : null}
      <div className="service-table__category-name">
        <CategoryIcon icon={icon} />
        <span dangerouslySetInnerHTML={getHighlightingText(name, search, !searchOption || searchOption === 'category-name')} />
      </div>
      <div className="service-table__category-actions">
        {id ? (
          <>
            {firstRender ? (
              <button
                className={classNames('font__weight-med dropdown-toggle btn btn-xs btn-default', {
                  dropup: isDropdownDropUp,
                })}
              >
                {' '}
                Actions
                {' '}
                <span className="caret" />
              </button>
            ) : (
              <ServicesDropdown
                id={id}
                handleSelect={onChangeAction}
                bsSize="xsmall"
                title="Actions"
                items={categoryActions}
                dropup={isDropdownDropUp}
              />
            )}
          </>
        ) : null}
      </div>
      {servicesLength ? (
        <div
          className={classNames('service-table__category-collapse', {
            'show-category': show,
            'hide-category': !show,
          })}
          onClick={onChangeCollapse}
        >
          <span className="service-table__category-collapse-name">
            {show ? 'Hide' : 'Show'}
            {' '}
            services (
            {servicesLength}
            )
          </span>
        </div>
      ) : null}
    </div>
  );
};

RowCategory.propTypes = {
  style: PropTypes.object,
  search: PropTypes.string,
  searchOption: PropTypes.string,
  category: PropTypes.object,
  serviceDispatch: PropTypes.func,
};

export default RowCategory;
